var _classCallCheck = require("/Users/natashameerbaum/Projects/twitter-wall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/natashameerbaum/Projects/twitter-wall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 0);
}([function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(1),
      o = n(3);

  function c(e) {
    return ~["GET", "HEAD"].indexOf(e.method.toUpperCase());
  }

  function s(e) {
    return e.url;
  }

  function u(e) {
    if (c(e)) {
      var _t = s(e),
          _n = r.Cache.get(_t);

      _n && (e.headers = Object.assign({}, e.headers, {
        "If-None-Match": _n.etag
      }));
    }

    return e;
  }

  function i(e) {
    if (c(e.config)) {
      var _t2 = e.headers.etag;
      _t2 && r.Cache.set(s(e.config), _t2, e.data);
    }

    return e;
  }

  function a(e) {
    if (304 === e.response.status) {
      var _n2 = (t = e.response.config, r.Cache.get(s(t)));

      if (!_n2) return Promise.reject(e);
      var _o = e.response;
      return _o.status = 200, _o.data = _n2.value, Promise.resolve(_o);
    }

    var t;
    return Promise.reject(e);
  }

  t.resetCache = function () {
    r.Cache.reset();
  }, t.default = function (e) {
    var t = o.default.create(e);
    return t.interceptors.request.use(u), t.interceptors.response.use(i, a), t;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = n(2);

  var o = /*#__PURE__*/function () {
    _createClass(o, null, [{
      key: "getInstance",
      value: function getInstance() {
        return this.instance || (this.instance = new o()), this.instance;
      }
    }, {
      key: "get",
      value: function get(e) {
        return this.getInstance().cache.get(e);
      }
    }, {
      key: "set",
      value: function set(e, t, n) {
        return this.getInstance().cache.set(e, {
          etag: t,
          value: n
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        this.getInstance().cache.flushAll();
      }
    }]);

    function o() {
      _classCallCheck(this, o);

      this.cache = new r();
    }

    return o;
  }();

  t.Cache = o;
}, function (e, t) {
  e.exports = require("node-cache");
}, function (e, t) {
  e.exports = require("axios");
}]);